import { Formik } from "formik";
import React, { useRef, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { Button, ThemeProviderV2 } from '@blueprint/ui';
import * as yup from "yup";
import styled from "styled-components";

import { FormSubmissionHandler } from "../../../types/common";
import { Loader } from "../../../common/components/core";

import PublicFormContainer from "./PublicFormContainer";
import PlatformTermsOfUse from "./PlatformTermsOfUse_v1_260511";

export type PlatformAgreementFormValues = {
    confirmed: boolean;
};

type PlatformAgreementFormProps = {
    onSubmit: FormSubmissionHandler<PlatformAgreementFormValues>;
    require: boolean;
};

const schema: yup.SchemaOf<PlatformAgreementFormValues> = yup.object().shape({
    confirmed: yup.boolean().required(),
});

const PlatformAgreementForm = ({
    onSubmit,
    require,
}: PlatformAgreementFormProps): JSX.Element => {

    const scrollRef = useRef<HTMLDivElement>();
    const [bottom, isBottom] = useState<boolean>(false);
    const [checked, setCheck] = useState<boolean>(false);

    const handleScroll = (event: any) => {
        if (event.nativeEvent) {
            const { scrollHeight, scrollTop, clientHeight } = event.nativeEvent.target;
            const nearBottom = Number(scrollHeight) - Number(scrollTop) - 20 <= Number(clientHeight);
            nearBottom ? isBottom(true) : isBottom(false)
        }
    }

    const handleCheckChange = () => {
        setCheck(!checked);
    }

    return (
        <PublicFormContainer>
            <ThemeProviderV2>
                <StyledModal show={require} backdrop="static" centered>
                    <Formik
                        validationSchema={schema}
                        validateOnBlur={false}
                        validateOnChange={false}
                        onSubmit={onSubmit}
                        initialValues={{
                            confirmed: false
                        }}
                    >
                        {({ handleSubmit, isSubmitting}) => (
                            <Loader overlay isLoading={isSubmitting}>
                                <Form
                                    autoComplete="off"
                                    noValidate
                                    onSubmit={handleSubmit}
                                >
                                <Modal.Header className="d-flex justify-content-center">
                                    <h1 className="mb-0 rem-1-5">Platform Terms of Use (“Terms”)</h1>
                                </Modal.Header>
                                <StyledModalBody onScroll={handleScroll} ref={scrollRef}>
                                    <PlatformTermsOfUse />
                                </StyledModalBody>
                                <Modal.Footer className="d-flex justify-content-center px-3">
                                    <Form.Check
                                        className="d-flex justify-content-center mb-2"
                                        style={{ width: '100%' }}
                                        type="checkbox"
                                        id="agree"
                                        label="&nbsp;I agree to the terms and conditions"
                                        disabled={!bottom}
                                        onChange={handleCheckChange}
                                    />
                                    <Button
                                        className="d-flex justify-content-center"
                                        variant="light.primary"
                                        disabled={!bottom || !checked}
                                        type="submit"
                                    >
                                        Confirm
                                    </Button>
                                </Modal.Footer>
                                </Form>
                            </Loader>
                        )}
                    </Formik>
                </StyledModal>
            </ThemeProviderV2>
        </PublicFormContainer>
    );
};

const StyledModal = styled(Modal)`
    .modal-dialog {
        max-width: 700px;
    }
`;
const StyledModalBody = styled(Modal.Body)`
    max-height: 640px;
    overflow-y: scroll;
    margin: 0.5rem;
`;
export default PlatformAgreementForm;
